import {
  PRODUCTION_TRANSLATION_ROOT,
  LOCAL_TRANSLATION_ROOT,
} from "./app_config";
import i18n, { InitOptions } from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import resourcesToBackend from "i18next-resources-to-backend";
import dayjs from "dayjs";

import "dayjs/locale/cs";
import "dayjs/locale/en";
import "dayjs/locale/sk";
import { isProduction } from "./helpers/enviromentHelpers";

export const DEFAULT_LANGUAGE = "cs";
export const SUPPORTED_LANGUAGES: SUPPORTED_LANGUAGES_TYPE[] = [
  "en",
  "cs",
  "sk",
];
export type SUPPORTED_LANGUAGES_TYPE = "en" | "cs" | "sk";

export const SUPPORTED_NAMESPACES = [
  "common",
  "customerportal-invite",
  "customerportal-common",
  "inputs",
  "errors",
  "order",
  "serviceObject",
  "intervention",
  "request",
  "company",
  "reports",
  "customer",
];

dayjs.locale("cs");

const options: InitOptions = {
  lng: "cs",
  fallbackLng: isProduction() ? DEFAULT_LANGUAGE : undefined,
  defaultNS: "common",
  ns: SUPPORTED_NAMESPACES,
  backend: {
    backends: [
      HttpBackend,
      resourcesToBackend(
        (lng: string, ns: string) => import(`./translations/${ns}/${lng}.json`),
      ),
    ],
    backendOptions: [
      {
        loadPath: `${import.meta.env.PROD ? PRODUCTION_TRANSLATION_ROOT : LOCAL_TRANSLATION_ROOT}/{{ns}}/{{lng}}.json`,
      },
    ],
  },
  supportedLngs: SUPPORTED_LANGUAGES,
  appendNamespaceToMissingKey: true,
  parseMissingKeyHandler: (key: string) => `?_${key}_?`,

  interpolation: {
    escapeValue: false,
  },

  react: {
    bindI18n: "languageChanged loaded",
    bindI18nStore: "added removed",
    nsMode: "default",
    useSuspense: true,
  },
  debug: !import.meta.env.PROD,
};

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(initReactI18next)
  .use(ChainedBackend)
  .use(I18nextBrowserLanguageDetector)
  .init(options);

export { i18n as i18nInit };
